import React from 'react';

import { Comparator } from './helpers/comparatorHelper';
import getControlsFactory from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/controls/ControlsFactory';
import TimestampControl from './TimestampControl';
import { Type, TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';

const ConditionInput = ({
  attr,
  disabled,
  'data-aid': dataAid,
  comparator,
  typeSpec,
}: {
  attr: string;
  'data-aid'?: string;
  disabled: boolean;
  comparator: Comparator;
  typeSpec?: TypeSpec;
}) => {
  const type = typeSpec?.type as Type;
  if (comparator === Comparator.doesNotExist || comparator === Comparator.exists || !type) {
    return null;
  }

  const comparatorInput = type === Type.timestamp ? props => <TimestampControl {...props} /> : getControlsFactory(type);

  if (!comparatorInput) {
    return null;
  }

  const renderControl = comparatorInput({ attr, 'data-aid': dataAid, typeSpec, comparator, disabled });

  return <>{renderControl}</>;
};

export default ConditionInput;
